module.exports = __webpack_public_path__ + "img/empty-icon.900ec1e9.png";